// Should match the list we have in our css and/or
// the list we have in our palette (palette/index)
const ICON_NAMES = [
  "arrow_back_ios",
  "arrow_forward_ios",
  "bin2",
  "cancel-circle",
  "checkmark",
  "circle-left",
  "circle-right",
  "cog",
  "cross",
  "enlarge",
  "facebook2",
  "file-text2",
  "flash_on",
  "forward",
  "home3",
  "image",
  "info",
  "instagram",
  "keyboard_arrow_left",
  "keyboard_arrow_right",
  "loop2",
  "meter",
  "minus",
  "pencil",
  "play_arrow",
  "play3",
  "plus",
  "redo",
  "spinner11",
  "stack",
  "undo",
] as const;

type IconName = (typeof ICON_NAMES)[number];

export { ICON_NAMES, type IconName };
